import React from 'react'
import styled from 'styled-components'
import { resizedImageUrl } from 'utils/imageUrl'
import { Text } from 'lib/Text'
import { useBrandPreview } from '../queries/useBrandPreview'

const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 14px;
`

const Content = styled.div`
  display: block;
`

const Image = styled.img`
  border: 1px solid black;
`

interface Props {
  slug: string
}
export const BrandPreviewLink = ({ slug }: Props) => {
  const { data, loading } = useBrandPreview({
    variables: {
      slug
    }
  })

  if (loading || !data?.brand) {
    return null
  }

  return (
    <Container>
      <Image alt={`${data.brand.title}`} src={resizedImageUrl(data.brand.primaryImageFullPath, { width: 48, height: 48 })} />

      <Content>
        <Text weight="semi" size="pxs">
          {data.brand.title}
        </Text>
      </Content>
    </Container>
  )
}
